import React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import {
  LinkBtn,
  LinkWrapper,
} from 'app/pages/library/videos/videoList/components/SendAndShare';

import { MdClose } from 'react-icons/md';
import { WheelsTVTable } from './WheelsTVTable';
import { FullScreenModal } from 'lib/components/FullScreenModal';

const Title = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  font-feature-settings:
    'tnum' on,
    'lnum' on,
    'ss02' on;
  color: ${props => props.theme.colors.secondary[100]};
`;

type Props = {
  handleModalClose: () => void;
  onCopy?: () => void;
};
export const ModalWheelsTV = ({ handleModalClose, onCopy }: Props) => {
  const { t } = useTranslation();

  return (
    <FullScreenModal
      headerLeft={
        <LinkWrapper>
          <LinkBtn onClick={handleModalClose}>
            <MdClose size='18' />
            <span>{t('Close')}</span>
          </LinkBtn>
        </LinkWrapper>
      }
      headerCenter={<Title>{t('Available WheelsTV Videos')}</Title>}
    >
      <WheelsTVTable handleModalClose={handleModalClose} onCopy={onCopy} />
    </FullScreenModal>
  );
};
